import React, { useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import { get } from 'lodash';
import { getHolidayStatus } from './api';
import { custom } from '../../utils/Api';

function useVacationStatusChecker(holidayCheckInfo) {
  // const { holidayCheckInfo } = useSelector(state => state.EmployeeHolidayReducer);
  const [info, setInfo] = useState();
  useEffect(() => {
    if (holidayCheckInfo) {
      setInfo(holidayCheckInfo);
    }
  }, [holidayCheckInfo]);

  const validateHolidayStatus = async (reqHours, editRecord = null) => {
    if (info.isHolidayCheckDisabled) {
      return {
        type: 'success',
        text: '',
      };
    }
    const holidayStatus = get(await custom(getHolidayStatus(info.payYear, info.masterId)), 'data.value[0]');
    if (holidayStatus) {
      const { Total, Sum } = holidayStatus;
      let hoursToSubtract = 0;

      if (editRecord && info.vacationIds.includes(editRecord.ClockCardEntryTypeID)) {
        hoursToSubtract = get(editRecord, 'ActualClockTime');
      }
      const totalHours = reqHours - hoursToSubtract;
      if (Sum >= totalHours) {
        return {
          type: 'success',
          text: '',
        };
      } else if (Total < totalHours) {
        return {
          type: 'error',
          text: <FormattedMessage id="time.warningText.NotEnoughVacationHours" />,
        };
      }
      return {
        type: 'warning',
        text: <FormattedMessage id="time.warningText.NotEnoughFirstOfMaiHours" />,
      };
    }
    return {
      type: 'error',
      text: <FormattedMessage id="time.warningText.NotEnoughVacationHours" />,
    };
  };

  return {
    validateHolidayStatus,
  };
}

export default useVacationStatusChecker;



// WEBPACK FOOTER //
// ./src/sites/time/useVacationStatusChecker.js